export const AUTHENTICATION_LOADING = 'auth/AUTHENTICATION_LOADING';
export const AUTHENTICATION_SUCCESS = 'auth/AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_FAILURE = 'auth/AUTHENTICATION_FAILURE';

export const GET_MENU_LOADING = 'menu/GET_MENU_LOADING';
export const GET_MENU_SUCCESS = 'menu/GET_MENU_SUCCESS';
export const GET_MENU_FAILURE = 'menu/GET_MENU_FAILURE';

export const LOGOUT = 'auth/LOGOUT';

export const INIT_APP = 'INIT_APP';
